import React, { Component } from 'react';
import { Row, Col, Card, Icon, Image, LocationPicker, MediaPlayer,Translate } from '$common';
import groupBy from 'lodash/groupBy';
import { withScriptjs, withGoogleMap, GoogleMap, Marker } from "react-google-maps";
import { convertLocation } from '$lib/normalize';
import CSSModules from 'react-css-modules';
import style from './answer-list.scss';
import cloneDeep from 'lodash/cloneDeep';
import Lightbox from 'react-images';
import { QuestionIconMap, QuestionAnswerTypeMap } from '$constants/task-form';

const inferAnswerType = type => {
  let result;

  Object.keys(QuestionAnswerTypeMap).forEach(key => {
    if (QuestionAnswerTypeMap[key].includes(type)) result = key;
  })

  return result;
}

let IMAGES = [];
let currentImageIndex = 0;

@CSSModules(style)
export default class AnswerList extends Component {
  
  state = this.createState()

  createState() {

    const {answers, questions} = this.getAnswersAndQuestions(this.props)
      return {
        answers: answers,
        questions: questions,
        currentImage: 0,
        lightboxIsOpen: false,
        images: []
      };
  }

  componentWillMount() {
    this.buildLightboxContent();
  }

  buildLightboxContent () {
    IMAGES = [];
    let imageIndex = 0;

    this.state.answers.map(answer => {
      if (answer.type === 'RawAnswer') {
        this.props.questions.map((question, index) => {
          if (['image_upload', 'image_capture', 'multiple_image_capture', 'multiple_image_upload'].includes(question.question_type) && question.id === answer.question_id) {
            IMAGES.push({
              src: answer.value
            });
            imageIndex++;
            answer.index = imageIndex;
          }
        })
      }
    });

    this.setState({ answers: this.state.answers });
    this.setState({ images: IMAGES });
  }

  getAnswersAndQuestions(props) {
    props = cloneDeep(props);

    props.questions.map((question,index) => {
      props.exempted_questions.map((exempted_question,index) => {
        if (question.id === exempted_question.id) {
          question.is_exempted = true
        }
      } )
      question.answers = []
      question.total_answers_point = 0;
      props.answers.map((answer, index) => {
        if (question.id === answer.question_id) {
          if (answer.type === "SelectionAnswer" && !question.is_exempted) {
            question.question_options.map((question_option,index) => {
              if (question_option.id === answer.question_option_id) {
                answer.answer_points = question_option.answer_points;
              }
            })
            question.total_answers_point += parseInt(answer.answer_points,10);
            }
          question.answers.push(answer); 
        }
      })
    })
	return {
      'answers': props.answers,
      'questions': props.questions};
  }

  openLightbox (index, event) {
    event.preventDefault();
    this.setState({
      currentImage: index,
      lightboxIsOpen: true
    });
  }

  closeLightbox(){
    this.setState({
      currentImage: 0,
      lightboxIsOpen: false,
    });
  }

  gotoPrevious () {
    this.setState({
     currentImage: this.state.currentImage - 1,
    });
  }

  gotoNext () {
    this.setState({
      currentImage: this.state.currentImage + 1,
    });
  }

  clickThumbnail (index) {
    this.setState({
      currentImage: index
    });
  }

  componentWillReceiveProps(nextProps) {
    const {answers, questions} = this.getAnswersAndQuestions(nextProps)
    this.setState({ answers: answers });
    this.setState({ questions: questions });
    this.buildLightboxContent();
  }

  renderResponse(question, order) {
    var answers = question.answers
    let answerType;
    answerType = answers.length > 0 ? answers[0].type : null;

    if (answerType === 'RawAnswer') {
      if (question.question_type === 'voice_record') {
        var response = (
          <ul styleName="sound-list">
            {answers.map((i, index) => (
              <li key={index}>
                <MediaPlayer url={i.value} height="60px"/>
              </li>
            ))}
          </ul>
        )
      } else if (['image_upload', 'image_capture', 'multiple_image_capture', 'multiple_image_upload'].includes(question.question_type)) {
        if ( !this.props.inLightbox ) {
          var response = (
            <ul styleName="image-list">
              {answers.filter(i => !i._destroy).map((i, index) => (
                <li key={index}>
                  <a styleName="image" href={i.value} onClick={e => ::this.openLightbox(i.index-1, e)}>
                    <Image
                      source={i.sid ? i.preview : (i.processed_value || i.value)}
                      cover
                      square
                      hideOnLoad
                    />
                  </a>
                </li>
              ))}
            </ul>
          )
        }
      } else if(question.question_type === 'video_capture') {
        var response = answers.filter(i => !i._destroy).map((i, index) => (
          <MediaPlayer url={i.value} key={index}/>
        ))
      } else {
        var response = answers[0].value;
      }
    } else if (answerType === 'GeoAnswer') {
      const Map = withScriptjs(withGoogleMap(props =>
        <GoogleMap
          defaultZoom={14}
          defaultCenter={convertLocation(answers[0].value)}
        >
          <Marker
            icon={require(`$shared/images/markers/accepted.png`)}
            position={convertLocation(answers[0].value)}
          />
        </GoogleMap>
      ));
      var response = (
        <Map
          googleMapURL={`https://maps.googleapis.com/maps/api/js?key=${process.env[0].GOOGLE_KEY}&v=3.exp&libraries=drawing,visualization`}
          loadingElement={
            <div style={{ height: `200px` }} />
          }
          containerElement={
            <div style={{ height: `200px` }} />
          }
          mapElement={
            <div style={{ height: `200px` }} />
          }
        />
      )
    } else if (answerType === 'SelectionAnswer') {
      var response = answers.map((i, index) => <p styleName='option' key={index}>{ `${i.extra_payload ? i.extra_payload+' / ' : ''}  ${i.value}` }</p>);
        if (this.props.is_scorable === true && !question.is_exempted) {
          var answer_point_response = answers.map((i,index) => <p styleName='option' key={index}>{ `${i.answer_points}` }</p>);
          var total_answers_point_response = <span dangerouslySetInnerHTML={{ __html: question.total_answers_point }} />
          var max_score_response = <span dangerouslySetInnerHTML={{ __html: question.max_answer_points }} />
        } else if (this.props.exempted_questions && this.props.exempted_questions.length > 0){
          var answer_point_response =<div styleName="exempt-content"> {Translate.get('exempted')} </div>
          var total_answers_point_response = <div styleName="exempt-content"> {Translate.get('exempted')} </div>
          var max_score_response = <div styleName="exempt-content"> {Translate.get('exempted')} </div>
        }
    } else {
      var response = null;
    }

    return (
      response && question.is_visible_client ? (
        <div styleName="response" key={Math.random()}>
          <Row>
            {
            !this.props.inLightbox ?
              <Col md="2/30" styleName="number">
                {order}
                {!question.is_required ? <span>*</span> : null}
              </Col>
              : ''
            }
            <Col md={this.props.inLightbox ? "6/30" : "6/30"}>
              <div styleName="question-meta">
                <div dir="ltr">
                  <Icon name={QuestionIconMap[question.question_type]} />
                </div>
                <div styleName="description">
                  <span dangerouslySetInnerHTML={{ __html: question.label }} />
                  <span>{question.description}</span>
                </div>
              </div>
            </Col>
            <Col md={this.props.inLightbox ? "6/30" : "6/30"}>
              {this.props.inLightbox ? <div>{response}</div> : response}
            </Col>
            <Col md={this.props.inLightbox ? "6/30" : "6/30"} styleName="center-value">
              {this.props.inLightbox ? <div>{answer_point_response}</div> : answer_point_response}
            </Col>
            <Col md={this.props.inLightbox ? "5/30" : "5/30"} styleName="center-value">
            {this.props.inLightbox ? <div>{total_answers_point_response}</div> : total_answers_point_response}
            </Col>
            <Col md={this.props.inLightbox ? "5/30" : "5/30"} styleName="center-value">
              {this.props.inLightbox ? <div>{max_score_response}</div> : max_score_response}
            </Col>
          </Row>
        </div>
      ) : null
    )
  }

  render() {
    const { questions } = this.state;
    
    return (
      <Card styleName="root">
        <Row>
          <Col>
            {questions.map((question, index) => this.renderResponse(question, index + 1))}
            {
              !this.props.inLightbox ? 
                <Lightbox
                  images={this.state.images}
                  currentImage={this.state.currentImage}
                  isOpen={this.state.lightboxIsOpen}
                  onClose={::this.closeLightbox}
                  onClickNext={::this.gotoNext}
                  onClickPrev={::this.gotoPrevious}
                  backdropClosesModal={true}
                  showThumbnails={true}
                  onClickThumbnail={::this.clickThumbnail}
                  zoom={true}
                />
              : ''
            }
          </Col>
        </Row>
      </Card>
    )
  }
}

AnswerList.defaultProps = {
  exempted_questions: [],
};



// WEBPACK FOOTER //
// ./src/components/submissions/show/answer-list.js